const HTML_TAG_PATTERN = /<[^>]*>/;
const SCRIPT_PATTERN = /javascript:/i;
const EVENT_HANDLER_PATTERN = /\bon[a-z]+\s*=/i;

/** Strip HTML tags and trim whitespace */
export const stripHtml = (value: string): string =>
  value.replace(/<[^>]*>/g, '').trim();

/** Detect HTML tags or script-like content in user input */
export const containsUnsafeMarkup = (value: string): boolean =>
  HTML_TAG_PATTERN.test(value) ||
  SCRIPT_PATTERN.test(value) ||
  EVENT_HANDLER_PATTERN.test(value);

/** Normalise optional string fields */
export const optionalString = (
  value: unknown,
  maxLength: number,
): string | undefined => {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }
  if (typeof value !== 'string') {
    return undefined;
  }
  const cleaned = stripHtml(value).slice(0, maxLength);
  return cleaned.length > 0 ? cleaned : undefined;
};

/** Normalise phone to digits and common separators */
export const normalisePhone = (phone: string): string =>
  phone.replace(/[^\d+\s()-]/g, '').trim();

/** Ensure website has a scheme */
export const normaliseWebsite = (website: string): string => {
  const trimmed = stripHtml(website).trim();
  if (!trimmed) {
    return trimmed;
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  return `https://${trimmed}`;
};

/** Basic email normalisation */
export const normaliseEmail = (email: string): string =>
  stripHtml(email).trim().toLowerCase();
